import React from 'react';
import ReactDOM from 'react-dom';
import LandingPage from '../pages/LandingPage';
import "../../less/app.less";
import "../../css/app.css";
import { Provider as ProviderRedux } from 'react-redux';
import store from '../redux/store';
import { PrivateRoute } from './PrivateRoute';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import Home from '../pages/Home';
import Dashboard from '../pages/Dashboard';
import Reports from '../pages/Reports';
import Mails from '../pages/Mails';
import MyAccount from '../pages/MyAccount';
import Search from '../pages/Search';
import PlatformUsersManagement from '../pages/PlatformUsersManagement';
import Document from '../pages/Documents';
import { ConfigProvider } from 'antd';
import ToDo from '../pages/ToDo';
import Archive from '../pages/Archive';
import Organisation from '../pages/Organisation';
import SendMailPortal from '../pages/SendMailPortal';
import Learning from '../pages/Learning';
import Accountant from '../pages/Accountant';
import Instructor from '../pages/Instructor';
import Signature from '../pages/Signature';
import AgentsPayments from '../pages/AgentsPayments';
import Stock from '../pages/Stock';
import Sellables from '../pages/Sellables';
import Provider from '../pages/Provider';
import Shops from '../pages/Shops';
import Sales from '../pages/Sales';
import Delivery from '../pages/Delivery';
import Order from '../pages/Order';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function App() {
  return /*#__PURE__*/_jsx(ConfigProvider, {
    theme: {
      token: {
        colorPrimary: '#0C4AA6',
        colorLink: '#0447A5',
        uploadPictureCardSize: '10px'
      }
    },
    children: /*#__PURE__*/_jsx(Router, {
      children: /*#__PURE__*/_jsxs(Routes, {
        children: [/*#__PURE__*/_jsx(Route, {
          exact: true,
          path: "/",
          element: /*#__PURE__*/_jsx(PrivateRoute, {
            children: /*#__PURE__*/_jsx(LandingPage, {})
          })
        }), /*#__PURE__*/_jsx(Route, {
          path: "/bonjour",
          element: /*#__PURE__*/_jsx(LandingPage, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "/portail",
          element: /*#__PURE__*/_jsx(SendMailPortal, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "/order",
          element: /*#__PURE__*/_jsx(Order, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "/order/:orderid",
          element: /*#__PURE__*/_jsx(Order, {})
        }), /*#__PURE__*/_jsxs(Route, {
          path: "home",
          element: /*#__PURE__*/_jsx(Home, {}),
          children: [/*#__PURE__*/_jsx(Route, {
            path: "/home",
            element: /*#__PURE__*/_jsx(Dashboard, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "dashboard",
            element: /*#__PURE__*/_jsx(Dashboard, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "accountant",
            element: /*#__PURE__*/_jsx(Accountant, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "delivery",
            element: /*#__PURE__*/_jsx(Delivery, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "payments",
            element: /*#__PURE__*/_jsx(AgentsPayments, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "sales",
            element: /*#__PURE__*/_jsx(Sales, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "sellables",
            element: /*#__PURE__*/_jsx(Sellables, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "shops",
            element: /*#__PURE__*/_jsx(Shops, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "providers",
            element: /*#__PURE__*/_jsx(Provider, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "stock",
            element: /*#__PURE__*/_jsx(Stock, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "users",
            element: /*#__PURE__*/_jsx(PlatformUsersManagement, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "account",
            element: /*#__PURE__*/_jsx(MyAccount, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "reports",
            element: /*#__PURE__*/_jsx(Reports, {})
          })]
        })]
      })
    })
  });
}
export default App;
if (document.getElementById('app')) {
  ReactDOM.render(/*#__PURE__*/_jsx(ProviderRedux, {
    store: store,
    children: /*#__PURE__*/_jsx(App, {})
  }), document.getElementById('app'));
}